import type { ColumnConfig } from '@/components/table/Table';

import {
  INTEGRATION_REQUEST_TYPE_LABELS,
  type IntegrationRequest,
  type IntegrationRequestStatus,
} from '../models/IntegrationRequest';
import { IntegrationRequestStatusBadge } from '../pages/IntegrationRequests/components/IntegrationRequestStatusBadge';

const formatDate = (value: string | null) =>
  value ? new Date(value).toLocaleDateString('es-UY') : '-';

export const integrationRequestsTableColumns: ColumnConfig[] = [
  {
    field: 'createdAt',
    label: 'Fecha ingreso',
    render: (value: string) => formatDate(value),
  },
  {
    field: 'commerce',
    label: 'Comercio',
    render: (_: unknown, row: IntegrationRequest) =>
      row.commerce ? (
        <span className='flex flex-col'>
          <span>{row.commerce.name}</span>
          {row.commerce.code && (
            <span className='text-xs text-gray-500'>código {row.commerce.code}</span>
          )}
        </span>
      ) : (
        '-'
      ),
  },
  {
    field: 'type',
    label: 'Tipo',
    render: (value: IntegrationRequest['type']) => INTEGRATION_REQUEST_TYPE_LABELS[value] ?? value,
  },
  {
    field: 'status',
    label: 'Estado',
    render: (value: IntegrationRequestStatus) => <IntegrationRequestStatusBadge status={value} />,
  },
  {
    field: 'contactEmail',
    label: 'Contacto',
    render: (_: unknown, row: IntegrationRequest) => (
      <span className='flex flex-col'>
        <span>{row.contactName}</span>
        <span className='text-xs text-gray-500'>{row.contactEmail}</span>
      </span>
    ),
  },
  {
    field: 'goLiveDate',
    label: 'Salida estimada',
    render: (value: string | null) => value || '-',
  },
  {
    field: 'requestedByName',
    label: 'Usuario',
    render: (value: string | null) => value || '-',
  },
];
